export const iconFontAwesomeMedicalHealthNotesMedical = (
	<i className="fa-solid fa-notes-medical"></i>
);
